import { render, staticRenderFns } from "./PolyglotSnack.vue?vue&type=template&id=c2f2c85c&scoped=true&"
import script from "./PolyglotSnack.vue?vue&type=script&lang=js&"
export * from "./PolyglotSnack.vue?vue&type=script&lang=js&"
import style0 from "./PolyglotSnack.vue?vue&type=style&index=0&id=c2f2c85c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f2c85c",
  null
  
)

export default component.exports